import React from 'react'

const ReportIcon20pxSvg = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.4917 1.66602H6.50832C3.47499 1.66602 1.66666 3.47435 1.66666 6.50768V13.4827C1.66666 16.5243 3.47499 18.3327 6.50832 18.3327H13.4833C16.5167 18.3327 18.325 16.5243 18.325 13.491V6.50768C18.3333 3.47435 16.525 1.66602 13.4917 1.66602ZM8.25832 13.491C8.25832 14.0243 7.82499 14.4577 7.28332 14.4577C6.74999 14.4577 6.31666 14.0243 6.31666 13.491V10.7743C6.31666 10.241 6.74999 9.80768 7.28332 9.80768C7.82499 9.80768 8.25832 10.241 8.25832 10.7743V13.491ZM13.6833 13.491C13.6833 14.0243 13.25 14.4577 12.7167 14.4577C12.175 14.4577 11.7417 14.0243 11.7417 13.491V6.50768C11.7417 5.97435 12.175 5.54102 12.7167 5.54102C13.25 5.54102 13.6833 5.97435 13.6833 6.50768V13.491Z" fill="#6B7280" />
        </svg>
    )
}

export default ReportIcon20pxSvg